// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__146DU","active":"NavigationItem_active__3rrNh"};